const copyToClipboard = (copiedText) => {
    navigator.clipboard.writeText(copiedText).then(() => { });
    return copiedText;
};
export { copyToClipboard };
